<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import FeatureSpotlight from 'dashboard/components-next/feature-spotlight/FeatureSpotlight.vue';
import Button from 'dashboard/components-next/button/Button.vue';

import toolsLight from 'assets/images/dashboard/pilot/tools-light.svg';
import toolsDark from 'assets/images/dashboard/pilot/tools-dark.svg';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};

// 假数据
const sampleTools = [
  {
    id: 1,
    title: '查询天气',
    description: '查询指定城市的实时天气信息',
    endpoint_url: 'https://api.weather.com/{{ city }}',
    http_method: 'GET',
    enabled: true,
  },
  {
    id: 2,
    title: '查询订单',
    description: '根据订单号查询订单详情和物流状态',
    endpoint_url: 'https://api.example.com/orders/{{ order_id }}',
    http_method: 'GET',
    enabled: true,
  },
  {
    id: 3,
    title: '创建工单',
    description: '为客户创建新的服务工单',
    endpoint_url: 'https://api.example.com/tickets',
    http_method: 'POST',
    enabled: false,
  },
];
</script>

<template>
  <FeatureSpotlight
    :title="$t('PILOT.CUSTOM_TOOLS.EMPTY_STATE.FEATURE_SPOTLIGHT.TITLE')"
    :note="$t('PILOT.CUSTOM_TOOLS.EMPTY_STATE.FEATURE_SPOTLIGHT.NOTE')"
    :fallback-thumbnail="toolsLight"
    :fallback-thumbnail-dark="toolsDark"
    class="mb-8"
    :hide-actions="true"
  />
  <EmptyStateLayout
    :title="$t('PILOT.CUSTOM_TOOLS.EMPTY_STATE.TITLE')"
    :subtitle="$t('PILOT.CUSTOM_TOOLS.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="space-y-3 px-4">
        <div
          v-for="tool in sampleTools"
          :key="tool.id"
          class="p-4 border border-n-container rounded-xl bg-n-slate-white dark:bg-n-slate-900"
        >
          <div class="flex items-start justify-between gap-4">
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 mb-1">
                <h4
                  class="text-sm font-medium text-n-slate-12 dark:text-n-slate-1"
                >
                  {{ tool.title }}
                </h4>
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs"
                  :class="
                    tool.enabled
                      ? 'bg-n-green-1 dark:bg-n-green-2 text-n-green-10 dark:text-n-green-9'
                      : 'bg-n-slate-1 dark:bg-n-slate-2 text-n-slate-10 dark:text-n-slate-9'
                  "
                >
                  {{ tool.enabled ? '已启用' : '已禁用' }}
                </span>
              </div>
              <p class="text-sm text-n-slate-10 dark:text-n-slate-4 mb-2">
                {{ tool.description }}
              </p>
              <div
                class="flex items-center gap-2 text-xs text-n-slate-9 dark:text-n-slate-5"
              >
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded font-mono"
                  :class="
                    tool.http_method === 'POST'
                      ? 'bg-n-amber-1 dark:bg-n-amber-2 text-n-amber-10 dark:text-n-amber-9'
                      : 'bg-n-blue-1 dark:bg-n-blue-2 text-n-blue-10 dark:text-n-blue-9'
                  "
                >
                  {{ tool.http_method }}
                </span>
                <span class="font-mono truncate">
                  {{ tool.endpoint_url }}
                </span>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <span class="i-lucide-edit h-4 w-4 text-n-slate-9" />
              <span class="i-lucide-trash h-4 w-4 text-n-slate-9" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('PILOT.CUSTOM_TOOLS.ADD_NEW')"
        icon="i-lucide-plus"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
